import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  authAgentData: {
    error: {
      isError: false,
      message: "",
    },
    items: [],
    loading: false,
  },
  openAgentLoginFlow: false,
  openAgentSignupFlow: false,
};

export const agentSignupSlice = createSlice({
  name: "registerAgentData",
  initialState,
  reducers: {
    setRegisteredAgentData: (state, action) => {
      state.authAgentData.items = action.payload;
    },
    setRegisteredAgentDataLoading: (state, action) => {
      state.authAgentData.loading = action.payload;
    },
    setRegisteredAgentDataError: (state, action) => {
      state.authAgentData.error = action.payload;
      state.authAgentData.items = [];
    },
    setAgentOpenSignupFlow: (state, action) => {
      if (action.payload === true) {
        const userToken = localStorage?.getItem("token");
        if (
          userToken &&
          userToken?.length > 0 &&
          userToken !== null &&
          userToken !== undefined &&
          userToken !== "null" &&
          userToken !== "undefined"
        ) {
          state.openAgentSignupFlow = false;
        } else {
          state.openAgentSignupFlow = action.payload;
        }
      } else {
        state.openAgentSignupFlow = action.payload;
      }
    },
    // setOpenLoginFlow: (state, action) => {
    //   if (action.payload === true) {
    //     const userToken = localStorage?.getItem("token");
    //     if (
    //       userToken &&
    //       userToken?.length > 0 &&
    //       userToken !== null &&
    //       userToken !== undefined &&
    //       userToken !== "null" &&
    //       userToken !== "undefined"
    //     ) {
    //       state.openLoginFlow = false;
    //     } else {
    //       state.openLoginFlow = action.payload;
    //     }
    //   } else {
    //     state.openLoginFlow = action.payload;
    //   }
    // },

    // setOpenVerifyEmailFlow: (state, action) => {
    //   if (action.payload === true) {
    //     const userToken = localStorage?.getItem("token");
    //     if (
    //       userToken &&
    //       userToken?.length > 0 &&
    //       userToken !== null &&
    //       userToken !== undefined &&
    //       userToken !== "null" &&
    //       userToken !== "undefined"
    //     ) {
    //       state.openVerifyEmail = false;
    //     } else {
    //       state.openVerifyEmail = action.payload;
    //     }
    //   } else {
    //     state.openVerifyEmail = action.payload;
    //   }
    // },

 
  },
});

// Action creators are generated for each case reducer function
export const {
    setRegisteredAgentData,
    setRegisteredAgentDataLoading,
    setRegisteredAgentDataError,
  
//   setOpenLoginFlow,
//   setOpenSignupFlow,
//   setOpenVerifyEmailFlow,
  
} = agentSignupSlice.actions;

export default agentSignupSlice.reducer;

export const loginItemsSelector = (state) => state.registerAgentData;
